import { CARD_ERRORS, s3Link } from "../../utils/constants";
import ppvLock from "../../images/silver-app.png";
import React, { useContext, useEffect, useState } from "react";
import currency from "currency.js";
import PAlert from "../PAlert";
import {
    setAlert,
    setCreditCardForm,
    updateCcVerification,
} from "../../../redux/actions";
import { connect, useDispatch } from "react-redux";
import { getChatGallery, setChatGalleryActiveMessage } from "../../../redux/actions/chatGallery";
import { showImageCounter, showVideoCounter } from "../../utils/helper";
import Media from "./media";
import { MediaContainerContext } from './MediaContainerContext';
import CountDownTimer from '../CountDownTimer';
import PriceText from '../PriceText';
import moment from 'moment';

const LockedMedia = ({
    message,
    filter,
    setAlert,
    setCreditCardForm
}) => {

    const dispatch = useDispatch();

    const [item, setItem] = useState(message);
    const [confirmPay, setConfirmPay] = useState(false);
    const [ppvFees, setPpvFees] = useState({});
    const [processingPay, setProcessingPay] = useState(false);
    const [imagePath, setImagePath] = useState('');
    const [busy, setBusy] = useState(false);
    const [msgId, setMsgId] = useState('');
    const [amount, setAmount] = useState(0);
    const [processPPV, setProcessPPV] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [alertBody, setAlertBody] = useState('');
    const [alertTitle, setAlertTitle] = useState(false);
    const [paidPpvs, setPaidPpvs] = useState([]);
    const [isDiscounted, setIsDiscounted] = useState(false);

    const { processingIntent } = useContext(MediaContainerContext);

    useEffect(() => {
        let mounted = true;

        if (message.has_free_preview) {
            setImagePath(`${s3Link}/${message.medias[0].file_path}`);
        } else {
            setImagePath(`${s3Link}/${message.medias[0].blurred_path}`);
        }

        if (message.is_bundle === 1) {
            setImagePath('./../../images/lockprof-themeblk-mob.jpg');
        }

        setItem(message);

        return () => {
            return mounted = false;
        };
    }, [message]);

    useEffect(() => {
        let mounted = true;
        if (processPPV) {
            ppvProcessPayment(amount, msgId);
        }
        return () => {
            return mounted = false;
        };
    }, [processPPV]);

    const showCcForm = () => {
        setCreditCardForm({
            show: true,
            prefilled: true,
            closeOnly: true,
            intent: 'PPV payment',
        });
    };

    const handleUnlockMedia = async (sender_id, price, message_id) => {
        await axios.post('/api/check/subscription', {
            user: sender_id,
            amount: price
        })
            .then((response) => {
                setConfirmPay(message_id);

                axios.get(`/api/transactions/fees_ppv`, {
                    params: {
                        pu: sender_id,
                        ppv_price: price
                    }
                })
                    .then(response => {
                        setPpvFees(response.data);
                    });

            })
            .catch(error => {
                console.log({ error });
                if (error.response.status == 403) {
                    setAlertTitle('Subscription Check');
                    setAlertBody('You must be subscribed to purchase a PPV');
                    setShowAlert(true);
                } else {
                    setAlertBody('There was an error in checking your subscription. Please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.');
                    setShowAlert(true);
                }
            });
    };

    const ppvProcessPayment = async (amount = null, msg_id = null) => {
        if (amount && msg_id) {
            setBusy(true);
            setProcessPPV(false);
            await axios.post('/api/transactions/ppv-pay', { amount: amount, user_id: message.sender_id, msg_id: msg_id })
                .then(response => {
                    if (!response.data.success && response.data.url) {
                        window.location = response.data.url;
                        return;
                    }

                    if (response.data.success === true && response.data.msg_error === '') {
                        setPaidPpvs([...paidPpvs, response.data.data.id]);
                        setProcessingPay(false);
                        setItem(response.data.data);

                        dispatch(setChatGalleryActiveMessage(response.data.data));
                    } else {
                        if (response.data.msg_error === '') {
                            setAlertBody('Please ensure you have sufficient funds and then try again.');
                            setShowAlert(true);
                        } else {
                            setAlertBody(response.data.msg_error);
                            setShowAlert(true);
                        }
                    }

                    setBusy(false);
                    setProcessingPay(false);
                })
                .catch(error => {
                    console.error({ error });
                    setBusy(false);
                    setProcessingPay(false);

                    if (error.response && error.response.status === 402) {
                        if (error.response.data.error === CARD_ERRORS.NO_CARD) {
                            showCcForm();
                            return;
                        } else if (error.response.data.error === CARD_ERRORS.NEEDS_VALIDATION) {
                            updateCcVerification({
                                showVerify: true
                            });
                            return;
                        } else {
                            showCcForm();
                            dispatch(setAlert({
                                show: true,
                                type: 'error',
                                body: error.response.data.message || 'Failed to process payment, please check your card details'
                            }));
                            return;
                        }
                    }

                    if (error.response && error.response.status === 400) {
                        updateShowVerification(true);
                        return;
                    }

                    if (error.response && error.response.status == 404) {
                        setAlert({
                            show: true,
                            type: 'error',
                            body: 'PPV is no longer available'
                        });
                        return;
                    }

                    if (error.response && error.response.status === 422) {
                        const responseData = error.response.data;
                        const firstErrorKey = Object.keys(responseData.errors);

                        setAlert({
                            show: true,
                            type: 'error',
                            body: responseData.errors[firstErrorKey][0] || 'Your card has been declined by your bank, please contact your bank or use another card.',
                            size: 'md'
                        });
                        return;
                    }

                    if (error.response && error.response.status === 409) {
                        setAlert({
                            show: true,
                            type: 'error',
                            body: error.response.data.error || 'PPV has already been purchased. Please reload the page'
                        });

                        setTimeout(() => {
                            $('.messenger-main').animate({ scrollTop: $(`#um-message-item-${msg_id}`).parent('div').offset().top }, 800);
                        }, 1000);

                        return;
                    }

                    if (error.response && error.response.status > 400 && error.response.status < 500) {
                        showCcForm();
                    }

                    let defaultMessage = 'There is an error processing the payment, please contact support <a href="https://priva.uvdesk.com/en/" target="_blank">here</a>.';
                    if (error.response && error.response.data.message) {
                        defaultMessage = error.response.data.message;
                    }
                    setAlert({
                        show: true,
                        type: 'error',
                        body: error.response.data.message || defaultMessage,
                        size: 'md'
                    });
                });
        } else {
            setProcessingPay(false);
        }
    };

    const payPPV = async (amount, m) => {
        let msg_id = m.id;
        setBusy(true);
        setAmount(amount);
        setMsgId(msg_id);
        setProcessingPay(true);
        await axios.get('/api/transactions/check', {
            params: {
                message_id: msg_id
            }
        })
            .then(response => {
                if (response.data.check) {
                    ppvProcessPayment(amount, msg_id);
                } else {
                    setCreditCardForm({
                        show: true,
                        prefilled: true,
                        closeOnly: true,
                        intent: 'PPV payment',
                    });
                    setProcessingPay(false);
                }
            })
            .catch(error => {
                console.log({ error });
                setBusy(false);
                setProcessingPay(false);
                dispatch(setAlert({
                    show: true,
                    type: 'error',
                    body: 'Failed to process ppv payment'
                }));
            });
    };


    const renderPaymentButton = (item, isProcessing) => {
        return !isProcessing && !processingIntent
            ? <div
                className={`ppv-unlock-btn`}
                onClick={() => payPPV(item.price, item)}
            >
                PAY <PriceText
                    price={message.price}
                    discountedPrice={message.promo_price}
                    isDiscounted={isDiscounted}
                />
            </div>
            : <div
                className={`ppv-unlock-btn`}
                style={{ cursor: 'wait' }}
            >PROCESSING...</div>;
    };

    const hasPreview = () => {
        return message.has_free_preview;
    };

    useEffect(() => {

        console.log("🚀 ~ useEffect ~ message:", message);
        if (message && Object.keys(message).length > 0) {
            const validDate = moment(message.expire_at).isValid();
            if (parseFloat(message.promo_price) > 0 && message.expire_at && !!validDate) {
                const expiry = moment.utc(message.expire_at).local();
                if (moment().isSameOrAfter(expiry, 'seconds')) {
                    setIsDiscounted(false);
                } else {
                    setIsDiscounted(true);
                }
            }
        } else {
            setIsDiscounted(false);
        }
    }, [message]);

    const handleEndTime = () => {
        setIsDiscounted(false);
    };

    return <>
        {
            hasPreview() ? <>
                <div className="ppv-unlock" id={`ppv-unlock-main-${message.id}`} style={{ height: 'fit-content', maxHeight: '-webkit-fit-content' }}>
                    <div className={'chat-gallery-media-container'}>
                        {
                            <Media key={`${message.medias[0].media_id}`}
                                media={message.medias[0]}
                                message={message}
                            />
                        }
                    </div>
                    <div className={'su-free-preview__stats'} style={{ width: '100%' }}>
                        <div className="gallery media-item__icon">
                            {showImageCounter(message.total_images)}
                            {showVideoCounter(message.total_videos)}
                        </div>
                        {
                            confirmPay === message.id
                                ? renderPaymentButton(message, processingPay)
                                : <div
                                    className="ppv-unlock-btn btn btn-primary btn-rounded"
                                    onClick={() => handleUnlockMedia(message.sender_id, message.price, message.id)}
                                >
                                    UNLOCK FOR&nbsp;<PriceText
                                        price={message.price}
                                        discountedPrice={message.promo_price}
                                        isDiscounted={isDiscounted}
                                    />
                                </div>
                        }

                        {
                            confirmPay === message.id
                                ? (
                                    ppvFees.fees && !!ppvFees.reg_gst && ppvFees.gst > 0
                                        ? <div className="ppv-chrg-text mb-1">{currency(ppvFees.fees).format()} processing fee plus {currency(ppvFees.gst).format()} GST will apply. </div>
                                        : <div className="ppv-chrg-text mb-1">{currency(ppvFees.fees).format()} processing fee will apply.</div>

                                )
                                : <div className="ppv-chrg-text"></div>
                        }

                        {
                            isDiscounted
                                ? <div className='promo_counter'>
                                    <span className="limited-offer-label">Limited offer expires in:</span>
                                    <br />
                                    <CountDownTimer
                                        dateTime={message.expire_at}
                                        id={message.id}
                                        onEndTime={handleEndTime}
                                        isEmphasized={true}
                                        isUTC
                                    />
                                </div>
                                : ''
                        }
                    </div>
                </div>
            </>
                : <>
                    <div className="ppv-unlock" id={`ppv-unlock-main-${message.id}`}
                        style={{ backgroundImage: `url('${imagePath}')`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', height: '40vh' }}
                    >
                        <div className="ppv-unlock-icon" id={`ppv-unlock-icon-${message.id}`}>
                            <img src={ppvLock} />
                        </div>
                        {
                            confirmPay === message.id
                                ? renderPaymentButton(message, processingPay)
                                : <div
                                    className="ppv-unlock-btn"
                                    onClick={() => handleUnlockMedia(message.sender_id, message.price, message.id)}
                                >
                                    UNLOCK FOR&nbsp;<PriceText
                                        price={message.price}
                                        discountedPrice={message.promo_price}
                                        isDiscounted={isDiscounted}
                                    />
                                </div>
                        }

                        {
                            confirmPay === message.id
                                ? (
                                    ppvFees.fees && !!ppvFees.reg_gst && ppvFees.gst > 0
                                        ? <div className="ppv-chrg-text mb-1">{currency(ppvFees.fees).format({ precision: 2 })} processing fee plus {currency(ppvFees.gst).format({ precision: 2 })} GST will apply. </div>
                                        : <div className="ppv-chrg-text mb-1">{currency(ppvFees.fees).format({ precision: 2 })} processing fee will apply.</div>

                                )
                                : <div className="ppv-chrg-text"></div>
                        }

                        {
                            isDiscounted
                                ? <div className='promo_counter'>
                                    <span className="limited-offer-label">Limited offer expires in:</span>
                                    <br />
                                    <CountDownTimer
                                        dateTime={message.expire_at}
                                        id={message.id}
                                        onEndTime={handleEndTime}
                                        isEmphasized={true}
                                        isUTC
                                    />
                                </div>
                                : ''
                        }

                        <div className="media-item__icon">
                            {showImageCounter(message.total_images)}
                            {showVideoCounter(message.total_videos)}
                        </div>
                    </div>
                </>
        }
        {
            showAlert && <PAlert
                show={showAlert}
                setShow={setShowAlert}
                title={alertTitle}
                body={alertBody}
            />
        }
    </>;
};

function mapStateToProps(state) {
    return {
        msgOptionOpen: state.message.msgOptionOpen,
        convIndex: state.message.convIndex,
        triggerScrollBottom: state.message.triggerScrollBottom,
        readCollection: state.message.read,
        filter: state.chatGallery.filter,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setAlert: payload => dispatch(setAlert(payload)),
        setCreditCardForm: payload => dispatch(setCreditCardForm(payload)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    {
        forwardRef: true
    })(React.memo(LockedMedia));
